<template>
 <div>
<!--   {{messagesAllByDate}}-->
   <div class="inbox-message">
     <span class="badge badge-info inbox-message-type-badge">Day Message</span>
     <div class="inbox-message-intro">
       <strong class="message-headline text-capitalize">{{ company_name }}: {{ selectDate | moment("dddd, MMMM DD, Y") }}</strong>
       <span class="badge badge-dark visible-badge"><i class="ico-eye_selected"></i>Visible to everyone</span>
       <span class="participants-count">Everyone has access to read this thread</span>
     </div>
   </div>
   <div class="inbox-comment-wrp" v-for="message in messagesAllByDate" >
     <div class="inbox-comment">
       <div class="avatar">AI</div>
       <div class="comment-content">
         <div class="comment-content-head">
           <strong class="comment-author-name text-capitalize">{{ message.user.name }}</strong>
           <div class="comment-content-head-rgt">
             <span class="comment-timestamp">{{ message.created_at | moment("MM.DD.Y HH:mm a") }}</span>
             <a href="javascript:void(0);" v-on:click="deleteMessage(message.id,message.roster_schedule_id)" class="btn btn-sm btn-outline-info delete-message">Delete</a>
           </div>
         </div>
         <p>{{ message.message }}</p>
       </div>
     </div>
   </div>
   <div class="text-center mb-10">
     <router-link :to="'/schedule/publish/'+roster_schedule_id+'/weeks/31/date/'+selectDate" class="btn btn-outline-info">View and answer in schedule</router-link>
   </div>
   <div class="message-followers-wrap">
<!--     <strong class="follower-headline">People notified on activity</strong>
     <div class="message-participants-wrp">
       <ul class="message-participants">
         <li>
           <span class="avatar">Ai</span>
         </li>
       </ul>
       <a href="#" class="btn btn-outline-info">Add/Remove</a>
     </div>-->
     <!--        <p>2 people get's a notification on new activity in this thread. Including yourself. <a class="text-red" href="#">Remove me</a></p>-->
   </div>
 </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";

export default {
  props: ["messagesAllByDate","selectDate","roster_schedule_id"],
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      company_name: this.$store.getters.getSelectedCompany.name,
    }
  },
  serverPrefetch() {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    deleteMessage(id,roster_schedule_id){
      if (confirm("Do you really want to delete?")) {
        axios.delete(this.$messages + '/' + id,
          {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status == 200) {
              this.$emit('send-result-values', this.selectDate,roster_schedule_id);
            }
          });
      }
    }
  }
}
</script>
